<div class="container">
  <div class="section">
    <h2>Data validation</h2>
    <div class="row">
      <div class="box">
        <div class="number">{{ cleansingSummary?.sum_of_tb || 0 }}</div>
        <div class="label">Sum of trial balance</div>
      </div>
      <div class="box">
        <div class="number">
          {{ cleansingSummary?.duplicated_acc_codes || 0 }}
        </div>
        <div class="label">Number of duplicate account codes</div>
      </div>
    </div>
  </div>

  <div class="section">
    <h2>Data identification</h2>
    <div class="row">
      <div class="box">
        <div class="number">{{ cleansingSummary?.account_code || "" }}</div>
        <div class="label">Account code</div>
      </div>
      <div class="box">
        <div class="number">
          {{ cleansingSummary?.account_description || "" }}
        </div>
        <div class="label">Account description</div>
      </div>
      <div class="box">
        <div class="number">
          {{ cleansingSummary?.account_trial_balance || "" }}
        </div>
        <div class="label">Trial balance amount</div>
      </div>
    </div>
  </div>

  <div class="section">
    <div class="header">
      <h2>Data ingestion</h2>
    </div>
    <div class="row">
      <div class="box">
        <div class="number">{{ cleansingSummary?.rows_ingested || 0 }}</div>
        <div class="label">Number of rows ingested</div>
      </div>
      <div class="box">
        <div class="number">{{ cleansingSummary?.records_cleansed || 0 }}</div>
        <div class="label flex">
          Number of records cleansed
          <motif-tooltip>
            <motif-tooltip-trigger>
              <motif-icon
                class="info-icon"
                size="16"
                [iconFunction]="IconoirInfoCircle"
                [tabIndex]="0"
                role="button"
                aria-label="Show Number of records cleansed tooltip information"
                aria-live="polite"
              ></motif-icon>
            </motif-tooltip-trigger>
            <motif-tooltip-content placement="auto">
              <div class="tooltip">
                <p>
                  {{ hoverableRecordsCleansed }}
                </p>
              </div>
              <motif-tooltip-arrow></motif-tooltip-arrow>
            </motif-tooltip-content>
          </motif-tooltip>
        </div>
      </div>
      <div class="box">
        <div class="number">{{ cleansingSummary?.records_removed || 0 }}</div>
        <div class="label flex">
          Number of records removed
          <motif-tooltip>
            <motif-tooltip-trigger>
              <motif-icon
                class="info-icon"
                size="16"
                [iconFunction]="IconoirInfoCircle"
                [tabIndex]="0"
                role="button"
                aria-label="Show Number of records removed tooltip information"
                aria-live="polite"
              >
              </motif-icon>
            </motif-tooltip-trigger>
            <motif-tooltip-content placement="auto">
              <div class="tooltip">
                <p>
                  {{ hoverableRecordsRemoved }}
                </p>
              </div>
              <motif-tooltip-arrow></motif-tooltip-arrow>
            </motif-tooltip-content>
          </motif-tooltip>
        </div>
      </div>
    </div>
  </div>
</div>
